export default __webpack_public_path__ + "static/logo-nyc-health-46536aafb62857dea72af019069b6493.png";